import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Leadership } from "@/components/site/Leadership";
import { Process } from "@/components/site/Process";
import { Compliance } from "@/components/site/Compliance";
import { Industries } from "@/components/site/Industries";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Leadership />
        <Process />
        <Compliance />
        <Industries />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
